/**
 * Whether this page load started from prerendered HTML (see
 * scripts/prerender.js) and React is still doing its first render.
 *
 * Read at module load, before React replaces #root: a prerendered page ships
 * its content already visible, so an entry animation that starts from
 * opacity 0 would make that content blink out and fade back in. Mount-time
 * animations are skipped for that first render only; App ends the window once
 * it has committed, so later in-app navigation animates as usual.
 */
let firstLoad =
  typeof document !== 'undefined' && !!document.getElementById('root')?.firstElementChild

export const isPrerenderedFirstLoad = () => firstLoad

export const endPrerenderedFirstLoad = () => {
  firstLoad = false
}
